module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nHkibf/tc-custom/9781488070020.jpg?1740799899278",
      "alt": "This image is the cover for the book Last Man She Expected, Welcome to Starlight"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Last Man She Expected, Welcome to Starlight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The town of Starlight can make being so wrong feel so right. Second in the series from the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author of "), _c('i', [_vm._v("The Best Intentions")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Falling for her arch nemesis . . . isn’t going to happen."), _c('br'), _c('br'), _vm._v("Moving to Starlight was Mara Reed’s first step forward after her devastating divorce. But had she known she’d find Parker Johnson, her ex-husband’s ruthless divorce attorney, there, she might have gone in a different direction. Away from the big city, Mara is seeing Parker in a new light—but is it enough for her to set aside her anger?"), _c('br'), _c('br'), _vm._v("From Harlequin Special Edition: Believe in love. Overcome obstacles. Find happiness.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michelle Major\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA Today bestselling author Michelle Major loves stories of new beginnings, second chances and always a happily ever after. An avid hiker and avoider of housework, she lives in the shadow of the Rocky Mountains with her husband, two teenagers and a menagerie of spoiled furbabies. Connect with her at www.michellemajor.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0